<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system/index';
	//Components
	import TemplateInputSettings from '../Components/TemplateInputSettings.svelte';
	//Helpers
	import { getTemplateService } from 'src/helpers/xt1_helpers/template_helpers';
	import IrrigationConfirmModal from './IrrigationConfirmModal.svelte';
	import { isSequenceRunning } from 'src/helpers/xt1_helpers/irrigation/irrigation_helpers';
	//Types
	import type { TemplateService } from 'src/types/VirtualComponents';
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let confirmModal: IrrigationConfirmModal;
	const templateService: TemplateService = getTemplateService(device);
	const zonesChannels = templateService.settings?.zones?.length;
</script>

<Alert
	class="mb-s"
	heading={$format('xt1_alert_limit_zones', {
		default: 'The number of zones that can be active at the same time.',
	})}
/>
<TemplateInputSettings {device} {confirmModal} setting="limit_zones" min={1} max={zonesChannels} />

{#if isSequenceRunning(device)}
	<IrrigationConfirmModal bind:this={confirmModal} />
{/if}
